import { Burger, Button, Divider, Drawer, Group, NavLink, Stack, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { Can } from '@sportybot-web/auth/permissions/can';
import { usePermissions } from '@sportybot-web/auth/permissions/use-permissions';
import { useAuth } from '@sportybot-web/auth/useAuth';
import { SportybotLogo } from '@sportybot-web/components/sportybot-logo';
import { Link } from '@tanstack/react-router';
import { Coins, Palette } from 'lucide-react';

import { NAV_LINKS } from '../constants';
import { CopyTokenButton } from '../copy-token-button';
import { ThemeToggle } from '../theme-toggle';
import { UserInfo } from '../user-info';
import classes from './mobile-nav.module.css';

const { link, ...drawerClasses } = classes;

export function MobileNav() {
  const { can } = usePermissions();
  const { authClient, user } = useAuth();
  const [opened, { toggle }] = useDisclosure();
  return (
    <>
      <Burger aria-label="Toggle navigation" hiddenFrom="sm" onClick={toggle} opened={opened} />
      <Drawer
        classNames={drawerClasses}
        onClose={toggle}
        opened={opened}
        position="right"
        title={<SportybotLogo />}
        transitionProps={{ duration: 400 }}>
        <Stack gap="space50">
          {NAV_LINKS.map(({ icon: Icon, label, permissions, to }) => {
            if (permissions && !can(permissions)) {
              return null;
            }

            return (
              <NavLink
                className={link}
                component={Link}
                key={to}
                label={label}
                leftSection={<Icon size={16} />}
                onClick={toggle}
                to={to}
              />
            );
          })}
        </Stack>

        <Stack gap="space200">
          <Group justify="space-between" px="space50">
            <Group align="center" gap="space100">
              <Palette size={16} />
              <Text>Theme</Text>
            </Group>
            <ThemeToggle />
          </Group>

          <Can action="CAN_COPY_ACCESS_TOKEN">
            <Group justify="space-between" px="space50">
              <Group align="center" gap="space100">
                <Coins size={16} />
                <Text>Access Token</Text>
              </Group>
              <CopyTokenButton />
            </Group>
          </Can>

          <Divider />

          <Group justify="space-between">
            <UserInfo emailVariant="body-1" fullNameVariant="body-1-emphasis" user={user} />
            <Button onClick={() => authClient.signOut()} size="compact-sm" variant="subtle">
              Log out
            </Button>
          </Group>
        </Stack>
      </Drawer>
    </>
  );
}
